import Radio from './Radio';
import RadioItem from './RadioItem';
Radio.RadioItem = RadioItem;
export default Radio;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/radio/index.js
// module id = 112
// module chunks = 0